<template>
  <el-dialog
    v-if="isShowDialog"
    :title="typeof role.id !== 'undefined' ? 'Edit Role' : 'Create New Role'"
    :visible.sync="isShowDialog"
    width="80%"
    top="5vh"
    :close-on-click-modal="false"
  >
    <el-form
      ref="roleEditForm"
      v-loading="isSaving"
      :label-position="'top'"
      :rules="rules"
      label-width="100px"
      :model="role"
    >
      <el-row>
        <el-col :md="24">
          <el-form-item
            label="Name"
            prop="name"
          >
            <el-input
              v-model="role.name"
              placeholder="Role Name"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="Description"
            prop="description"
          >
            <el-input
              v-model="role.description"
              placeholder="Role Description"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="Level"
            prop="level"
          >
            <el-select
              v-model="role.level"
              :loading="!levels.length > 0"
              value-key="id"
              placeholder="Role Level"
              class="w-100"
              clearable
            >
              <el-option
                v-for="level in levels"
                :key="level.id"
                :label="level.description"
                :value="level"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isShowDialog = false">
        Cancel
      </el-button>
      <el-button
        :loading="isSaving"
        type="primary"
        @click.native="typeof role.id !== 'undefined' ? updateRole() : createRole()"
      >
        {{ typeof role.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      role: {},
      levels: [],
      isShowDialog: false,
      isSaving: false,
      rules: {
        name: [
          { required: true, message: 'Please input role name', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Please input role description', trigger: 'blur' }
        ],
        level: [
          { required: true, message: 'Please select role level', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.$sdk.level.list(builder => {
      builder.page = 1
      builder.limit = 1000
      builder.order = 'uuid:asc'
    })
      .then(res => {
        this.levels = res
      })
  },
  methods: {
    createRole () {
      this.$refs.roleEditForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.role.create(this.role, builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShowDialog = false
              this.$emit('saved')
            })
        }
      })
    },
    updateRole () {
      this.$refs.roleEditForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.role.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShowDialog = false
              this.$emit('saved')
            })
        }
      })
    }
  }
}
</script>
